import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors;
export var button = /*#__PURE__*/css("background:none;border:0;color:", colors.neutral.heavy.default, ";margin-top:10px;cursor:pointer;padding:0;outline:none;font-weight:600;font-size:", font.smallFontSize, ";&:hover{color:", colors.neutral.medium.hover, ";}");
export var buttonIcon = {
  name: "540lu8",
  styles: "width:14px;height:14px;"
};
export var buttonLabel = {
  name: "2k2f2j",
  styles: "display:inline-block;vertical-align:middle;margin-left:3px;"
};